export default {
	documents: {
		previewError: {
			line1: 'Unfortunately, the preview could not be displayed.',
			line2: 'Please open or save the document!',
		},
		relatedFiles: 'Files related to the document',
		noFilesInContainer: 'No files have been found in the document containers.',
		noFilesMatchSearch: 'No files match your search',
		downloadAll: 'Download all',
		selectAll: '@:common.selectAll',
		deselectAll: 'Deselect all',
		clearSelection: 'Clear selection',
		attachments: 'Attachments',
		searchPlaceholder: 'Search files...',
		sortBy: 'Sort by',
		perPage: 'Per page',
		showing: 'Showing',
		of: 'of',
		groups: 'Groups',
		folders: 'Folders',
		files: 'Files',
		noFolder: 'No folder',
		noDocumentType: 'No document type',
		dropzone: {
			title: 'Drop files here to upload',
			hint: 'Allowed: {types} — max. {maxSize} MB per file',
		},
		view: {
			list: 'List view',
			container: 'Folder view',
			grouped: 'Document types',
		},
		tooltip: {
			list: 'List view',
			container: 'Folder view',
			grouped: 'Document type view',
		},
		sort: {
			typeAsc: 'Document type: A-Z',
			typeDesc: 'Document type: Z-A',
			createdDesc: 'Newest first',
			createdAsc: 'Oldest first',
			nameAsc: 'Name: A-Z',
			nameDesc: 'Name: Z-A',
		},
	},
}
